import { render, staticRenderFns } from "./PermissionDetails.vue?vue&type=template&id=53a7c420&scoped=true&"
import script from "./PermissionDetails.vue?vue&type=script&lang=js&"
export * from "./PermissionDetails.vue?vue&type=script&lang=js&"
import style0 from "./PermissionDetails.vue?vue&type=style&index=0&id=53a7c420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a7c420",
  null
  
)

export default component.exports